export default __webpack_public_path__ + "static/media/icons8-reply-arrow-100.7b9f4756.svg";